import React from 'react';
import PrimaryButtonLink from '../components/PrimaryButtonLink';
import PageSection from '../components/PageSection';
import ServiceCard from '../components/ServiceCard';
import InfoList from '../components/InfoList';

const services = [
  {
    title: 'Web app su misura',
    description:
      'Piattaforme veloci e scalabili per gestire vendite, processi interni e customer care in un unico flusso.',
    icon: '🌐'
  },
  {
    title: 'App mobile iOS e Android',
    description:
      'Esperienze mobile intuitive con performance elevate, notifiche push e integrazione completa ai tuoi sistemi.',
    icon: '📱'
  },
  {
    title: 'CRM dedicato e vendite in mobilita',
    description:
      'Sviluppiamo CRM su misura per rete commerciale, agenti e back office con accesso rapido anche da smartphone e tablet.',
    icon: '🧩'
  },
  {
    title: 'Creazione di agenti AI',
    description:
      'Creiamo agenti AI per semplificare le attivita della tua azienda, con workflow intelligenti e integrazioni sui tuoi strumenti.',
    icon: '🤖'
  }
];

const processSteps = [
  {
    title: '1. Analisi rapida',
    items: [
      'Raccogliamo obiettivi, vincoli e priorita di business.',
      'Definiamo backlog iniziale e piano di delivery.',
      'Stima tempi e investimento con metriche chiare.',
      'Identifichiamo i processi candidati ad automazione AI.'
    ]
  },
  {
    title: '2. Prototipo e sviluppo',
    items: [
      'Wireframe e UX validati con il tuo team.',
      'Sviluppo iterativo con demo frequenti.',
      'QA continuo e test funzionali ad ogni sprint.'
    ]
  },
  {
    title: '3. Go-live e crescita',
    items: [
      'Rilascio in produzione con monitoraggio attivo.',
      'Supporto evolutivo e ottimizzazioni continue.',
      'Roadmap trimestrale basata sui risultati reali.'
    ]
  }
];

const faq = [
  {
    title: 'Quanto tempo serve per iniziare?',
    description:
      'Dopo la call iniziale possiamo partire in pochi giorni lavorativi con analisi, piano operativo e kickoff tecnico.'
  },
  {
    title: 'Lavorate anche su progetti gia esistenti?',
    description:
      'Si. Possiamo intervenire su software esistenti, fare refactoring, integrare nuovi moduli e migliorare performance e sicurezza.'
  },
  {
    title: 'Posso richiedere solo una fase specifica?',
    description:
      'Si. Possiamo lavorare su discovery, UX/UI, sviluppo, integrazione o manutenzione, anche in modalita modulare.'
  }
];

const HeroSection = () => {
  return (
    <section className="hero hero-secondary">
      <div className="container hero-inner">
        <p className="eyebrow">Sviluppo Software su Misura</p>
        <h1>Trasformiamo la tua idea in software che produce risultati reali.</h1>
        <p className="hero-subtitle">
          Progettiamo e sviluppiamo web app, app mobile e piattaforme custom per aziende
          che vogliono crescere piu velocemente con processi digitali solidi.
        </p>
        <div className="hero-actions">
          <PrimaryButtonLink to="/contatti">Richiedi una call gratuita</PrimaryButtonLink>
        </div>
      </div>
    </section>
  );
};

const ServiceSection = () => {
  return (
    <PageSection
      title="Cosa possiamo sviluppare per te"
      intro="Soluzioni costruite intorno ai tuoi obiettivi, non pacchetti preconfezionati."
    >
      <div className="service-grid">
        {services.map(service => (
          <ServiceCard key={service.title} {...service} />
        ))}
      </div>
    </PageSection>
  );
};

const ProcessSection = () => {
  return (
    <PageSection
      title="Metodo operativo"
      intro="Un processo semplice, trasparente e pensato per ridurre rischi e tempi morti."
    >
      <div className="info-grid">
        {processSteps.map(step => (
          <InfoList key={step.title} title={step.title} items={step.items} />
        ))}
      </div>
    </PageSection>
  );
};

const FaqSection = () => {
  return (
    <PageSection title="Domande frequenti">
      <div className="framework-grid">
        {faq.map(item => (
          <article className="framework-card" key={item.title}>
            <h3>{item.title}</h3>
            <p>{item.description}</p>
          </article>
        ))}
      </div>
    </PageSection>
  );
};

const FinalCtaSection = () => {
  return (
    <PageSection title="Vuoi un preventivo chiaro in 48 ore?">
      <div className="cta-panel">
        <div>
          <h3>Parliamo del tuo progetto</h3>
          <p>
            Raccontaci obiettivi e tempi: prepariamo una proposta tecnica con roadmap,
            budget e prossimi passi.
          </p>
        </div>
        <div className="hero-actions">
          <PrimaryButtonLink to="/contatti">Prenota una call</PrimaryButtonLink>
        </div>
      </div>
    </PageSection>
  );
};

const SviluppoSuMisura = () => {
  return (
    <>
      <HeroSection />
      <ServiceSection />
      <ProcessSection />
      <FaqSection />
      <FinalCtaSection />
    </>
  );
};

export default SviluppoSuMisura;
